export default __webpack_public_path__ + "static/media/hristina.524cebf9.jpg";